import { AxiosResponse } from "axios";
import axiosInstance from "@lib/axios";
import { MessageResponseType } from "@features/payments";

export const customerPortal = async (): Promise<MessageResponseType> => {
    const { data }: AxiosResponse<MessageResponseType> = await axiosInstance.get("/stripe/customerPortal");

    return data;
};
